<template>
  <div class="check-form">
    <div class="check-list">
      <Card
        :check-fields="interact"
        :labels="formData"
        :isAccountNumberMasked="isAccountNumberMasked"
        :randomBackgrounds="randomBackgrounds"
        :backgroundImage="backgroundImage"
      />
    </div>
    <div class="check-form__inner">

      <div class="check-form__group w-100">
        <div class="check-input w-100">
          <label for="accountType" class="check-input__label">Account Type</label>
          <select :id="interact.accountType"
                  class="check-input__input w-100"
                  v-model="formData.accountType"
                  v-validate="'required'"
                  name="account type"
                  data-check-field
                  autocomplete="off">
            <option value="">Select</option>
            <option value="checking">Checking</option>
            <option value="savings">Savings</option>
          </select>
        </div>
      </div>
      
      <div class="row">
        <div class="col-md-6">
          <div class="check-input w-100">
            <label for="firstname" class="check-input__label">First Name</label>
            <input type="text"
                   :id="interact.firstname"
                   v-model="formData.firstname"
                   class="check-input__input w-100"
                   v-validate="'required'"
                   name="first name"
                   data-check-field
                   autocomplete="off" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="check-input w-100">
            <label for="lastname" class="check-input__label">Last Name</label>
            <input type="text"
                   :id="interact.lastname"
                   v-model="formData.lastname"
                   class="check-input__input w-100"
                   v-validate="'required'"
                   name="last name"
                   data-check-field
                   autocomplete="off" />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6">
          <div class="check-form__group w-100">
            <div class="check-input w-100">
              <label for="bankName" class="check-input__label">Bank Name</label>
              <input type="text"
                     :id="interact.bankName"
                     @input="changeBankName"
                     class="check-input__input w-100"
                     :value="formData.bankName"
                     v-validate="'required'"
                     name="bank name"
                     data-check-field
                     autocomplete="off" />
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="check-input w-100">
            <label for="cardZip" class="card-input__label">Zip</label>
            <input type="text"
                   :id="interact.cardZip"
                   @input="changeZip"
                   v-model="formData.cardZip"
                   class="card-input__input"
                   v-number-only
                   maxlength="5"
                   v-validate="'required'"
                   name="zip"
                   data-card-field
                   autocomplete="off" />
          </div>
        </div>
      </div>

      

      <div class="row">
        <div class="col-lg-6">
          <div class="check-input">
            <label for="routingNumber" class="check-input__label">Routing Number</label>
            <input type="text"
                   :id="interact.routingNumber"
                   @focus="focusRoutingNumber"
                   @blur="blurRoutingNumber"
                   class="check-input__input"
                   v-model="formData.routingNumber"
                   v-validate="'required'"
                   maxlength="9"
                   v-number-only
                   name="routing number"
                   data-check-field
                   autocomplete="off" />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="check-input">
            <label for="accountNumber" class="check-input__label">Account Number</label>
            <input type="text"
                   :id="interact.accountNumber"
                   @focus="focusAccountNumber"
                   @blur="blurAccountNumber"
                   class="check-input__input"
                   v-model="formData.accountNumber"
                   v-validate="'required'"
                   maxlength="17"
                   v-number-only
                   name="account number"
                   data-check-field
                   autocomplete="off" />
          </div>
        </div>

      </div>

      

        
      
    </div>
  </div>
</template>

<script>
import Card from './Card'
export default {
  name: 'CardForm',
  directives: {
    'number-only': {
      bind (el) {
        function checkValue (event) {
          event.target.value = event.target.value.replace(/[^0-9]/g, '')
          if (event.charCode >= 48 && event.charCode <= 57) {
            return true
          }
          event.preventDefault()
        }
        el.addEventListener('keypress', checkValue)
      }
    },
    'letter-only': {
      bind (el) {
        function checkValue (event) {
          if (event.charCode >= 48 && event.charCode <= 57) {
            event.preventDefault()
          }
          return true
        }
        el.addEventListener('keypress', checkValue)
      }
    }
  },
  props: {
    formData: {
      type: Object,
      default: () => {
				return {
					bankName: '',
					routingNumber: '',
          accountNumber: ''
        }
      }
    },
    backgroundImage: [String, Object],
    randomBackgrounds: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Card
  },
  data () {
    return {
			interact: {
				bankName: 'v-bank-name',
				routingNumber: 'v-routing-number',
        accountNumber: 'v-account-number'        
      },

			isAccountNumberMasked: true,
      mainAccountNumber: this.accountNumber
      
    }
  },
  computed: {
    
  },

  mounted() {
    this.maskAccountNumber()
  },
  methods: {
    changeBankName(e) {
			this.formData.bankName = e.target.value;
			this.$emit('input-bank-name', this.formData.bankName);
		},

		changeRoutingNumber(e) {
			this.formData.routingNumber = e.target.value;
			this.$emit("input-routing-number", this.formData.routingNumber);
		},

		changeZip(e) {
			this.$emit('input-zip', this.formData.zip);
		},

		changeAccountNumber(e) {
      this.formData.accountNumber = e.target.value
      let value = this.formData.accountNumber.replace(/\D/g, '')
			if (this.formData.accountNumber.length < 4) {
				this.$message.error("Please enter a valid account number");
			} else {
        this.$emit('input-account-number', this.formData.accountNumber)
			}
      
			
		},

    handleSubmit() {

      

			this.$validator.validateAll().then(valid => {
				if (!valid) {
					this.$message.error("All fields are required");
				} else {
					if (this.formData.accountNumber.length < 4) {
						this.$message.error("Please enter a valid account number");
					} else {
						this.$emit("valid");
					}
					
				}
			});
      
		},

		blurAccountNumber() {
			if (this.isAccountNumberMasked) {
				this.maskAccountNumber();
			}
		},
    blurRoutingNumber () {
     
    },
    maskAccountNumber () {
			this.mainAccountNumber = this.formData.accountNumber;
			this.formData.accountNumberReal = this.mainAccountNumber;
      let arr = this.formData.accountNumber.split('')
      arr.forEach((element, index) => {
        if (index > 4 && index < 14 && element.trim() !== '') {
          arr[index] = '*'
        }
      })
      //this.formData.cardNumber = arr.join('')
    },
    unMaskAccountNumber () {
      this.formData.accountNumber = this.mainAccountNumber
		},

		focusRoutingNumber() {

		},

    focusAccountNumber () {
      this.unMaskAccountNumber()
    },
    toggleMask () {
      this.isAccountNumberMasked = !this.isAccountNumberMasked
      if (this.isAccountNumberMasked) {
        this.maskAccountNumber()
      } else {
        this.unMaskAccountNumber()
      }
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/style.scss";
</style>